"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
class PayoutRequestsProvider extends DataProvider_1.default {
    get fragments() {
        return {
            PayoutRequest: () => `
        ... on PayoutRequest {
          id
          userId
          amount
          status
          time
          declineReason
          externalFee
        }
      `,
            PayoutRequestSettings: () => `
        ... on PayoutRequestSettings {
          userId,
          minimumAmount
        }
      `,
        };
    }
    search({ data }, fields) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.query("payoutRequestFind", { data }, this.getPageableFragment("PayoutRequest", fields));
        });
    }
    getSettings({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.query("payoutRequestGetSettings", { data }, this.getFragment("PayoutRequestSettings"));
        });
    }
    pay({ id }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("payoutRequestPay", { id });
        });
    }
    decline({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("payoutRequestDecline", { data });
        });
    }
    undo({ id }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("payoutRequestUndo", { id });
        });
    }
    generate({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("payoutRequestGenerate", { data }, this.getFragment("PayoutRequest"));
        });
    }
    create({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("payoutRequestCreate", { data }, this.getFragment("PayoutRequest"));
        });
    }
    getStats() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.query("statsPayouts", undefined, "... on StatsData { info }");
        });
    }
}
exports.PayoutRequestsProvider = PayoutRequestsProvider;
//# sourceMappingURL=PayoutRequestsProvider.js.map